import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { DatePicker, Flex, Select, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getManagers } from 'src/store/Slices/DropDownSlice'
import { editClent, getClientsList } from 'src/store/Slices/ClientsSlice';

const EditManagerModal = ({
    visible,
    setVisible,
    clientInfo,
    addEditPayload
}) => {

    // HELPERS
    const dispatch = useDispatch()

    const managersList = useSelector(state => state.DropDownSlice.managersList)

    // STATE
    const [manager, setManager] = useState()

    // FUNCTIONS
    const onClickEditManager = () => {
      dispatch(editClent({
        managerId: manager,
        id: clientInfo.id,
      }))
          .then(() => {
            dispatch(getClientsList(addEditPayload))
            setVisible(false)
          })
    }

    useEffect(() => {
        
    }, [visible])


    return (
        <>
            <CModal
                alignment="center"
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="VerticallyCenteredExample"
            >
                <CModalHeader>
                    <CModalTitle id="VerticallyCenteredExample">Выбрать менеджера</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                        <>
                            <div>
                                <Typography.Title level={5}>Менеджер</Typography.Title>
                                <Select
                                    onClick={() => { dispatch(getManagers()) }}
                                    style={{ width: '100%' }}
                                    options={managersList?.data?.value}
                                    onChange={e => setManager(e)}
                                    value={manager}
                                    placeholder='Выбрать'
                                    onSelect={(e, b) => {setManager(e)}}
                                />
                            </div>
                        </>
                    </Flex>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary text-light" onClick={() => {setVisible(false)}}>
                        Закрыть
                    </CButton>
                    <CButton color="primary text-light" onClick={onClickEditManager}>Сохранить</CButton>
                </CModalFooter>
            </CModal>
        </>
    )
}

export default EditManagerModal